module.exports = "<div class=\"leftsettingbox\">\r\n        <ul class=\"list-unstyled settinglist\">    \r\n            <li><a [routerLink]=\"['paymentList']\"  routerLinkActive=\"selected\"><strong>Payment List</strong></a></li>\r\n         \r\n        </ul>     \r\n    </div>  \r\n      <div class=\"padding-zero\">      \r\n        <router-outlet></router-outlet>\r\n    </div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/kccLko/paymentLko/paymentLko.component.html
// module id = ./src/app/crm/kccLko/paymentLko/paymentLko.component.html
// module chunks = main